import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { todayChile } from '@/lib/utils'

// Landing pública F1 — puerta de entrada al login.
export default function Landing() {
  const today = todayChile()

  return (
    <main className="min-h-dvh bg-white">
      <div className="mx-auto flex min-h-dvh max-w-3xl flex-col items-start justify-center gap-6 px-6 py-12">
        <div className="inline-flex items-center gap-2 rounded-full bg-fitlab-gradient px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-white shadow-sm">
          <span className="size-2 rounded-full bg-white/90" aria-hidden />
          Salud Ocupacional
        </div>

        <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">
          <span className="bg-fitlab-gradient bg-clip-text text-transparent">FITLAB</span>
        </h1>

        <p className="max-w-prose text-base leading-relaxed text-slate-600">
          Plataforma de salud ocupacional. Gestión de fichas clínicas, informes médicos, tableros
          ejecutivos y comunicación automatizada con trabajadores y empresas.
        </p>

        <Link to="/login">
          <Button size="lg" rightIcon={<ArrowRight className="h-4 w-4" />}>
            Ingresar al sistema
          </Button>
        </Link>

        <div className="text-sm text-slate-500">
          <p>
            Entorno: <span className="font-mono text-slate-700">Fase 1 — MVP productivo</span>
          </p>
          <p>
            Fecha Santiago: <span className="font-mono text-slate-700">{today}</span>
          </p>
        </div>

        <p className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-xs leading-relaxed text-amber-900">
          Acceso restringido. Contenido sujeto a acuerdo de confidencialidad WipXap SpA / FITLAB.
        </p>
      </div>
    </main>
  )
}
